import axios from "axios";
import { toast } from "react-toastify";

export const addLeagueVote = async (userId, goalId, token) => {
  try {
    const data = {
      userId,
      goalId,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL_USER}/leagues/voteGoal`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.data) {
      toast.error(`${error.response.data?.message}`);
      // throw new Error(error.response.data.message);
    } else {
      toast.error(`${error.message}`);
      // throw new Error(error.message);
    }
  }
};
